module.exports = __webpack_public_path__ + "static/img/watericonblack.2d04beac.png";